import React from 'react';
import { Trans } from 'react-i18next';
import { Box } from '@material-ui/core';
import { H3, Subtitle } from 'react-design-components';
import useHelp from './hooks/useHelp';

const CreditPaymentHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="credit_payment" t={t}>
      <Box mb={3}>
        <H3>Gutschrift</H3>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Fallen die Vorauszahlungen, die der Mieter im Voraus geleistet hat, zu hoch aus, entsteht eine Gutschrift für
          den Mieter. Dieses ist vom Vermieter
          <b>umgehend zu erstatten.</b>
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Für die Überweisung des Betrags hat der Vermieter eine Frist von 30 Tagen, wenn nicht anders mietvertraglich
          vereinbart. Auch eine Einsichtnahme in die Belege der Nebenkostenabrechnung gewähren dem Vermieter keinen
          Aufschub der Erstattung. Die 30-Tage-Frist gilt weiterhin.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Eine
          <b>Verrechnung</b>
          mit zukünftigen Zahlungsforderungen ist gültig, wenn sich beide Parteien darauf verständigt haben.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Hält sich Ihr Vermieter an die gesetzliche Zahlungsfrist? Welche Regelungen sind in Ihrem Mietvertrag
          vereinbart?
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default CreditPaymentHelp;
